// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.widget-numbers[data-v-5252bf00] {\n  font-size: 20px;\n}\n.impr-item[data-v-5252bf00] {\n  height: 100% !important;\n}\n.mainMarginTop[data-v-5252bf00] {\n  margin-top: 10px !important;\n}\n@media screen and (min-width: 1024px) {\n.topmainrow[data-v-5252bf00] {\n\t\tdisplay: block;\n}\n}\n@media screen and (max-width: 1024px) {\n.topmainrow[data-v-5252bf00] {\n\t\tdisplay: none;\n}\n}\n", ""]);
// Exports
module.exports = exports;
